<template>
  <div class="boss-main-wrap boss-main-content-wrap">
    <div class="grid-x hide-for-print">
      <div class="cell auto pega-usage-notes">
        <job-preview-provision-list-link class="pega-accordion-link-header" />
      </div>
      <print-button class="cell shrink" />
    </div>
    <template v-if="clientJobEdit">
      <preview-job
        :is-show-comment="false"
        :is-show-text-count="true"
        :is-client-job="true"
        :job-info="jobInfo"
        :company-interview="companyInterview"
        :company-info="companyInfo"
        :about-apply="aboutApply"
      />
      <preview-code-setting
        :is-show-comment="false"
        :is-client-job="true"
        :code-setting="codeSetting"
        :official-company-name="''"
        :display-company-name="''"
        :company-name-kana="''"
        :is-not-output-google-for-jobs="false"
      />
    </template>
    <!-- メッセージ作成 -->
    <div class="pega-preview">
      <job-edit-examination-request-create
        v-model="messageBody"
        :is-over-length="isOverLengthBody"
        :is-all-required-filled="isAllRequiredFilled"
        :status-code="statusCode"
        :max-message-body="maxMessageBody"
        @back="onEdit"
        @submitted="onSubmitted"
      />
    </div>
    <!-- メッセージ履歴 -->
    <div class="pega-preview">
      <client-job-edit-preview-message-sent-history
        :messages="messages"
        class="margin-bottom-3"
      />
    </div>
  </div>
</template>

<script>
import PrintButton from '@/components/atoms/PrintButton'
import JobPreviewProvisionListLink from '@/components/atoms/JobPreviewProvisionListLink'
import PreviewJob from '@/components/organisms/PreviewJob'
import PreviewCodeSetting from '@/components/organisms/PreviewCodeSetting'
import * as clientJobConverter from '@/lib/clientJob/clientJobConverter'
import JobEditExaminationRequestCreate from '@/components/molecules/JobEditExaminationRequestCreate.vue'
import ClientJobEditPreviewMessageSentHistory from '@/components/organisms/ClientJobEditPreviewMessageSentHistory'
import util from '@/lib/util'

export default {
  components: {
    PrintButton,
    JobPreviewProvisionListLink,
    PreviewJob,
    PreviewCodeSetting,
    JobEditExaminationRequestCreate,
    ClientJobEditPreviewMessageSentHistory
  },
  data () {
    return {
      companyId: '',
      jobEditId: '',
      clientJobEdit: null,
      messages: [],
      messageBody: ''
    }
  },
  computed: {
    maxMessageBody: () => 2000,
    jobInfo () {
      return clientJobConverter.toJobInfo(this.clientJobEdit)
    },
    companyInterview () {
      return clientJobConverter.defaultCompanyInterview
    },
    companyInfo () {
      return clientJobConverter.toCompanyInfo(this.clientJobEdit)
    },
    aboutApply () {
      return clientJobConverter.toAboutApply(this.clientJobEdit)
    },
    codeSetting () {
      return clientJobConverter.toCodeSetting(this.clientJobEdit)
    },
    isOverLengthBody () {
      return this.messageBody.length > this.maxMessageBody
    },
    isAllRequiredFilled () {
      return this.clientJobEdit ? this.clientJobEdit.isAllRequiredFilled : false
    },
    statusCode () {
      return this.clientJobEdit ? this.clientJobEdit.currentExaminationStatusCode : ''
    }
  },
  created () {
    this.$set(this, 'companyId', this.$route.params.companyId)
    this.$set(this, 'jobEditId', this.$route.params.jobEditId)
    this.fetchClientJobEdit()
    this.fetchMessages()
  },
  methods: {
    fetchClientJobEdit () {
      this.$http.secured.get(`/preview/edit/companies/${this.companyId}/client/jobs/${this.jobEditId}/request`).then(response => {
        this.$set(this, 'clientJobEdit', response.data)
      })
    },
    fetchMessages () {
      this.$http.secured.get(`/preview/edit/companies/${this.companyId}/client/jobs/${this.jobEditId}/request/messages`).then(messagesResponse => {
        this.$set(this, 'messages', messagesResponse.data)
      })
    },
    onSubmitted () {
      this.$dialog.confirm('原稿の審査を申請しますか？<br>（メッセージがある場合は同時に送信されます）').then(() => {
        this.requestExamination()
      })
      // いいえを押下した時（catch句を消すとコンソールに警告が出るから消さないでね！！）
        .catch(() => {})
    },
    requestExamination () {
      this.$http.secured.put(
    `/preview/edit/companies/${this.companyId}/client/jobs/${this.jobEditId}/examination/_request`,
    { message: this.messageBody, statusUpdateAt: this.clientJobEdit.statusUpdatedAt }
      ).then(() => {
        this.$toasted.global.success({ message: '申請しました' })
        util.closeAndReloadOpener(window)
      }).catch(() => {})
    },
    onEdit () {
      window.location.href = `${process.env.ADM_ENDPOINT}/client-offer/offer-edit?offerEditId=${this.jobEditId}&companyId=${this.companyId}`
    }
  }
}
</script>
